
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import TacosScreen from './tacos';

const ITEM_WOOD_BG = require('./assets/tablabk.png');

function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [showTacos, setShowTacos] = useState(false);


     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundImage: `url(${ITEM_WOOD_BG})`,
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                textDecoration: 'none',
                width: 330,
                minHeight: 450,
                margin: '0px 0px 15px',
                textAlign: 'left',
                paddingTop: 14,
                paddingBottom: 16,
                paddingInline: 14,
                boxSizing: 'border-box',
                position: 'relative',
                borderRadius: 30,
               
            }}>
                <div style={{ width: '100%', padding: 13, boxSizing: 'border-box' }}>
                    <img
                        src={image}
                        style={{
                            width: '100%',
                            height: 254,
                            objectFit: 'cover',
                            borderRadius: 6,
                            display: 'block',
                            marginTop: 30
                        }}
                    />
                </div>
                <h3 style={
                    {
                        fontWeight: '100',
                        color: '#fff',
                        textTransform: 'uppercase',
                        fontSize: 25,
                        margin: '15px 0 6px',
                        textAlign: 'center',
                        fontFamily: 'Galantic',
                        lineHeight: 0.9,
                        textShadow: '0px 3px 0px rgba(28, 18, 10, 0.98), 0px 7px 12px rgba(0, 0, 0, 0.45)',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        marginTop: 5
                    }
                    }>
                    
                    {translate("es", data.language, data.name)}
                    {/* {langEng ? data.name : translate(i18n.language, data.language, data.name)} */}
                
                </h3>
                
                <div style={{width: '70%', margin: '0 auto'}}>
                    <p
                        className='shor-text'
                        style={{
                            fontFamily: 'Arial',
                            fontSize: 16,
                            color: '#f4f4f4',
                            textAlign: 'center',
                            margin: 0,
                            fontWeight: '500',
                            lineHeight: 1.1,
                            textShadow: '0px 2px 8px rgba(0, 0, 0, 0.8)',
                            paddingInline: 16,
                          
                        }}>

                        {`${data.regular_decription.replace(/\\n/g,'\n')}`}
                        {/* {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        } */}
                        
                        
                    </p>
                </div>
            </div>
        );
    }
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  showCocktails={ setShowCocktails}  showLamp={ false}  goCategories={setshowCategories} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div style={{
                    background: 'linear-gradient(180deg, #5f3c24 0%, #4a2f1d 55%, #3a2416 100%)',
                    width: '93%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '8px 10px',
                    gap: 15,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 12,
                    border: '1px solid rgba(205, 140, 86, 0.45)',
                    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.3), inset 0px 1px 0px rgba(255, 214, 170, 0.18)'
                }}>
                    {menusData.map((item, key) => {
                        if (![767, 444, 445, 446, 448, 449, 450, 429,
                            1018, 1025, 1026, 1027, 1028, 
                            430, 425, 424, 555, 565,
                            564, 566, 567, 791, 798, 792, 797
                        ].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: 'linear-gradient(180deg, #c48a52 0%, #a96b3a 60%, #8b552f 100%)',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '10px 25px',
                                    borderRadius: 10,
                                    minWidth: 'fit-content',
                                    border: '1px solid rgba(89, 48, 21, 0.6)',
                                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.25), inset 0px 1px 0px rgba(255, 220, 180, 0.28)'
                            }}
                                    onClick={() => { 
                                        if (item.id === 855) {
                                            setShowTacos(true);
                                        } else {
                                        setMenus(item.menus)       
                                        }
                                     
                                }}
                                >
                                    <p className='shor-text' style={{
                                        color: '#f8d28e', fontFamily: 'serif', fontSize: 16,
                                        margin: 0, textTransform: 'uppercase',
                                        fontWeight: '500', fontFamily: 'Galantic',
                                        lineHeight: 1,
                                        textShadow: '0px 2px 0px rgba(75, 39, 14, 0.9), 0px 4px 6px rgba(0, 0, 0, 0.35)'
                                    }}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>
                <div >
                    <div style={{
                       
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            gap: '4%',
                            padding: '0px 20px 100px 20px',
                            maxHeight: 625,
                        overflow: 'scroll',
                        position: 'relative',
                        zIndex: 100,
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                        


              
                    </div>   
                    
      
  {/* <img
              
                        style={{
                          width: 300,
                            height: 300,
                           
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                                right: 0,
                            zIndex: 1
                            
                        
                      }}
                src={require('./assets/FLAME-DECORATION.png')}
                alt="Logo"
            />  */}
                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                {showTacos && <TacosScreen setShowHappy={setShowTacos} />}

            </LayoutContent>
        </div>
    );
}
export default Index;